












































import { Component, Prop, Emit, Vue, Watch } from 'vue-property-decorator';
@Component({})
export default class FlDnD extends Vue {
  @Prop({ default: 'border-dashed border-2 border-black' }) outlineClass: string;
  @Prop({ default: () => [] }) extensions: Array<string>;
  @Prop({ default: 1 }) uploadMaxCount: number;
  @Prop({ default: -1 }) maxFileSize: number;
  @Prop({ default: false }) disabled: boolean;
  private fileError: string = null;
  @Emit('input')
  input(fileList: any) {
    return fileList;
  }
  dragging: boolean = false;

  inputFile(event: any, type: string) {
    this.dragging = false;
    let files = null;
    if (type == 'drop') {
      if (!event.dataTransfer || !event.dataTransfer.files[0]) {
        return false;
      }
      files = event.dataTransfer.files;
    } else {
      if (!event.target || !event.target.files) {
        return false;
      }
      files = event.target.files;
    }

    if (!files || files.length === 0) {
      return false;
    }

    // ファイル数のバリデーション
    if (files && files.length > this.uploadMaxCount) {
      this.$set(
        this,
        'fileError',
        `ファイルを${files.length}個指定されました。送信できるファイル数は${this.uploadMaxCount}までです。`
      );
      return false;
    }

    // ファイル形式のバリデーション
    let invalidExtIndex = Object.keys(files).find((key: string) => {
      const ext = files[key].name.substring(files[key].name.lastIndexOf('.') + 1).toLowerCase();
      return !this.extensions.includes(ext);
    });

    if (invalidExtIndex !== undefined) {
      const ext = files[invalidExtIndex].name.substring(files[invalidExtIndex].name.lastIndexOf('.') + 1);
      this.$set(
        this,
        'fileError',
        `${ext}は対応していないフォーマットです。${this.extensions.join(',')}のファイルをアップロードしてください。`
      );
      return false;
    }

    // ファイルサイズのバリデーション
    if (this.maxFileSize > 0) {
      const invalidFileSize = Object.keys(files).filter((key: string) => {
        return files[key].size > this.maxFileSize;
      });

      if (invalidFileSize.length > 0) {
        this.$set(
          this,
          'fileError',
          `ファイルサイズは${this.formatBytes(this.maxFileSize)}以下のサイズのみアップロード可能です。`
        );
        return false;
      }
    }

    this.input(files);
  }

  formatBytes(bytes, decimals = 2) {
    if (bytes === 0) return '0 Bytes';

    const k = 1024;
    const dm = decimals < 0 ? 0 : decimals;
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

    const i = Math.floor(Math.log(bytes) / Math.log(k));

    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
  }
}
